import Text, { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import { COLOR_VALUES } from "shared/config/colors";
import styled, { css } from "styled-components/macro";

export const StyledWrapper = styled.div`
    border-radius: 4px;
    border: 1px solid ${COLOR_VALUES.Gray_6};
    padding: 12px;
    width: 212px;
`;

export const CardTitle = styled(Text)`
    padding-bottom: 8px;
    letter-spacing: 0.14px;
`;

export const DateButton = styled.button`
    ${TEXT_VARIANT_STYLES.Descriptive_1_1};
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: ${COLOR_VALUES.Black};
    border: none;
    background: transparent;
    padding: 0;
    text-align: center;
    cursor: default !important;

    &:focus-visible {
        outline: none;
    }

    ${(props) =>
        props.isHoliday &&
        css`
            cursor: pointer !important;
            border: 2px solid ${COLOR_VALUES.Black};
            background: ${COLOR_VALUES.White};
        `};

    ${(props) =>
        props.isDisabled &&
        css`
            border: none;
            color: ${COLOR_VALUES.Gray_4};
        `};

    ${(props) =>
        props.isCurrent &&
        css`
            background: ${COLOR_VALUES.Gray_7};
        `};
`;
